import React from 'react';
import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';

import Button from 'eventbrite_design_system/button/Button';

const PricingCallout = ({
    onClick,
    linkText,
    descriptionPrimary,
    descriptionSecondary,
}) => (
    <div className="eds-text-bl eds-l-pad-bot-2 eds-l-pad-top-6">
        <p className="eds-text-color--white eds-text-weight--heavy pricing-callout-override-text">
            {descriptionPrimary}{' '}
            <Button
                style="anchor"
                onClick={onClick}
                __containerClassName="eds-text-bm eds-text-weight--regular eds-text-color--ui-blue-inverse"
            >
                {linkText}
            </Button>
        </p>
        <p className="eds-text-color--white eds-text-weight--heavy pricing-callout-override-text">
            {descriptionSecondary}
        </p>
    </div>
);

PricingCallout.propTypes = {
    /*
    Function to fire when link is clicked
    */
    onClick: PropTypes.func,
    /*
    Text for link
    */
    linkText: EBPropTypes.translation,
    /*
    Primary text that appears next to the link
    */
    descriptionPrimary: EBPropTypes.translation,
    /*
    Secondary text that appears below the link
    */
    descriptionSecondary: EBPropTypes.translation,
};

export default PricingCallout;
